import WeddingStory from "./WeddingStory";
export default WeddingStory;